import { EditorExtensionEnum as e } from "../enums/editor-extensions-enum.mjs";
//#region src/constants/default-extensions.ts
var t = [
	e.Document,
	e.Paragraph,
	e.Text,
	e.History
], n = [
	...t,
	e.Bold,
	e.Italic,
	e.Strike,
	e.Underline,
	e.BulletList,
	e.OrderedList,
	e.ListItem,
	e.HardBreak
], r = [
	...n,
	e.TextStyle,
	e.FontFamily,
	e.Heading,
	e.TextAlign,
	e.Link,
	e.TextColor,
	e.TextBackgroundColor,
	e.FontSize,
	e.LineHeight,
	e.Indent,
	e.SpecialCharacters,
	e.Image,
	e.DropCursor
], i = [...r, e.Substitution], a = [
	...t,
	e.Substitution,
	e.CharacterCount,
	e.SimpleLink,
	e.SimpleHardBreak
];
//#endregion
export { r as advancedTextEditorExtensions, t as baseExtensions, i as emailTextExtensions, a as extensionsForSms, n as simpleTextExtensions };
